import { render, staticRenderFns } from "./log_page.vue?vue&type=template&id=0c4e1a42&scoped=true"
import script from "./log_page.vue?vue&type=script&lang=js"
export * from "./log_page.vue?vue&type=script&lang=js"
import style0 from "./log_page.vue?vue&type=style&index=0&id=0c4e1a42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e1a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4e1a42')) {
      api.createRecord('0c4e1a42', component.options)
    } else {
      api.reload('0c4e1a42', component.options)
    }
    module.hot.accept("./log_page.vue?vue&type=template&id=0c4e1a42&scoped=true", function () {
      api.rerender('0c4e1a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/logs/log_page.vue"
export default component.exports